import { type BannerProps } from '@printdeal/ui-library';

export const getJustifyValue = (alignment: string): BannerProps['justify'] => {
  const justify: Record<string, BannerProps['justify']> = {
    right: 'end',
    left: 'start',
  };

  return justify[alignment.toLowerCase()];
};
